import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { QuoteReceipt } from "../../../../../components/QuoteReceipt";
import { AcceptOfferReceiptFragment } from "./AcceptOfferReceipt.fragment";
export const AcceptOfferReceipt = t0 => {
  const $ = _c(7);
  const {
    initialPrices,
    quote: quoteKey,
    applyCreatorFee,
    onCreatorFeeChange
  } = t0;
  let t1;
  if ($[0] !== quoteKey) {
    t1 = readFragment(AcceptOfferReceiptFragment, quoteKey);
    $[0] = quoteKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const quote = t1;
  let t2;
  if ($[2] !== applyCreatorFee || $[3] !== initialPrices || $[4] !== onCreatorFeeChange || $[5] !== quote) {
    t2 = <QuoteReceipt applyCreatorFee={applyCreatorFee} initialPrices={initialPrices} onCreatorFeeChange={onCreatorFeeChange} quote={quote} />;
    $[2] = applyCreatorFee;
    $[3] = initialPrices;
    $[4] = onCreatorFeeChange;
    $[5] = quote;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};